import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import ButtonDownload from '../ButtonDownload/ButtonDownload'
import {deviceMax} from "../../theme/breakpoints";

export const StyledContainer = styled.div`
  flex-direction: column;
  display: flex;
`

export const StyledTitle = styled.p`
  margin: ${pxToRem(10)} 0;
  font-weight: ${({theme}) => theme.fonts.weight.bold};
  font-size: ${({theme}) => theme.fonts.sizes.button};
  line-height: ${({theme}) => theme.fonts.lineHeight.cta};
`

export const StyledContentContainer = styled.div`
  display: flex;
  max-width: ${pxToRem(792)};
  width: 100%;
  gap: ${pxToRem(20)};
  background-color: white;
  overflow-x: auto;

  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
`

export const StyledButtonDownload = styled(ButtonDownload)`
  max-width: ${pxToRem(364)};
  min-width: 45%;

  @media ${deviceMax.tablet} {
    max-width: ${pxToRem(320)};
  }
  @media ${deviceMax.mobileL} {
    width: 100%;
    max-width: ${pxToRem(320)};
    min-width: none;
  }

`

export const StyledDocumentContainer = styled.div`
  display: flex;
  max-width: ${pxToRem(792)};
  width: 100%;
  background-color: white;
  flex-wrap: wrap;
  flex-direction: row;
  gap: ${pxToRem(20)};
  @media ${deviceMax.mobileL} {
    flex-direction: column;
  }
`
